<dx-popup
  [(visible)]="visible"
  [showTitle]="false"
  [showCloseButton]="false"
  [shading]="true"
  shadingColor="rgba(0, 0, 0, 0.3)"
  (onShowing)="onShowingHandler()"
  (onHiding)="onHidingHandler()"
  [width]="width"
  [height]="height"
  [maxHeight]="maxHeight"
  [maxWidth]="maxWidth"
  [dragEnabled]="false"
  [hideOnOutsideClick]="allowOutsideClick"
  [wrapperAttr]="{ class: fill ? 'gpd-popup gpd-popup-fill' : 'gpd-popup' }"
>
  <div class="gpd-popup-inner" #popupContent tabindex="0" (keydown.enter)="onEnter()">
    <div class="gpd-popup-header">
      <div class="gpd-popup-title-group">
        <app-svg-icon
          *ngIf="titleIcon"
          [icon]="titleIcon"
          [size]="20"
          color="#f5a623"
          class="gpd-popup-title-icon"
        ></app-svg-icon>
        <span class="gpd-popup-title">{{ title }}</span>
      </div>
      <app-gpd-button type="text" icon="cancel" (onClick)="visible.set(false)"></app-gpd-button>
    </div>
    <div class="gpd-popup-body" #popupBody>
      <div *ngIf="content" class="gpd-popup-content" [innerHTML]="content"></div>
      <ng-content></ng-content>
    </div>
    <div class="gpd-popup-footer">
      <div class="gpd-popup-footer-left">
        @for (button of leftButtons; track $index) {
          <app-gpd-button
            [type]="button.type ?? 'secondary'"
            [text]="button.text"
            [icon]="button.icon"
            (onClick)="onButtonClick(button)"
          ></app-gpd-button>
        }
      </div>
      <div class="gpd-popup-footer-right">
        @for (button of buttons; track $index) {
          <app-gpd-button
            [type]="button.type ?? 'primary'"
            [text]="button.text"
            [icon]="button.icon"
            [disabled]="button.disabled ?? false"
            (onClick)="onButtonClick(button)"
          ></app-gpd-button>
        }
      </div>
    </div>
  </div>
</dx-popup>
